export default __webpack_public_path__ + "static/photoGalleryModule_cloud_top-9693fd44f5341b2f0cef2bb95b03fb5d.png";